// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"4983443f","543":"610507ec","660":"85ebd0a1"}[chunkId] + ".chunk.css";
};